import React from 'react';
import { useAppSelector } from 'store/hooks';
import { selectOnboardingTradingAccountForOnboardingFunnel } from 'features/invest/reducers/selectors';
import UnderReview from '../UnderReview';
import OnboardingFunnel from './OnboardingFunnel';
import DisplayNextOnboardingStep from '../DisplayNextOnboardingStep';
import InvestInitialScreen from '../InvestInitialScreen';
import { isWeb } from '../../../../constants';
const InvestOnboardingFunnel = () => {
    const account = useAppSelector(selectOnboardingTradingAccountForOnboardingFunnel);
    const status = account?.account?.status;
    const requiredUserAction = account?.account.requiredUserAction;
    const hasOnboardingState = useAppSelector((state) => !!state.invest.onboarding);
    if (!status) {
        // Onboarding steps stay in the mobile app. On web the intro's buttons show the QR code modal.
        if (hasOnboardingState && !isWeb) {
            return <DisplayNextOnboardingStep broker="seccl"/>;
        }
        return <InvestInitialScreen />;
    }
    if (status === 'NOT_STARTED' || status === 'CLOSED') {
        if (isWeb) {
            return <InvestInitialScreen />;
        }
        return <DisplayNextOnboardingStep broker={account.account.broker}/>;
    }
    if (status === 'FROZEN' || status === 'NOT_ELIGIBLE' || status === 'CLOSING_IN_PROGRESS') {
        return <UnderReview status={status} requiredUserAction={requiredUserAction}/>;
    }
    if (status === 'JISA_TRANSFER_REQUIRED' || status === 'JISA_CONVERTED') {
        return null;
    }
    return <OnboardingFunnel status={status} accountId={account.account.id}/>;
};
export default InvestOnboardingFunnel;
